import React, { FC } from 'react';

interface Props {
    boxStyle?: 1;
    pos?: 'top' | 'right' | 'bot' | 'left';
    msg: React.ReactNode;
    children: React.ReactNode;
    width?: number | string;
}

export const ToolTip: FC<Props> = (props) => {
    const { boxStyle = 1, pos = 'bot', msg, children } = props;
    return (
        <div className="tooltip-box__outer" style={props.width ? { width: '100%' } : undefined}>
            {children}
            <div className={`tooltip-box__inner tooltip-box__pos-${pos}`}>
                <div className={`tooltip-box__content tooltip-box__style${boxStyle}`}>{msg}</div>
            </div>
        </div>
    );
};
